<!--
* UI Name: Filter Right Layout
* Modify Date: 2023/01/01
-->
<template>
  <dialog-drag
    :id="id"
    :ref="'dialog-' + id"
    @close="removeDialog"
    @drag-end="dialogDragEnd"
    @drag-start="selectDialog"
    @move="dialogDragEnd"
    :rightSticky="true"
    class="cus-bg-dialog"
    style="top:0;right:0;left:auto"
  >
    <template v-slot:title>
      <v-card-title class="headline white--text px-6 mr-5" primary-title>
        <v-btn
          disabled
          class="mb-1 mr-1 proc-button-style proc-filter drag-drawflow"
          x-small
          height="30"
          width="30"
          color="proc darken-1"
        >
          <icon-svg :size="procIconSize" iconName="proc-filter" />
        </v-btn>
        <font class="text-xl font-bold leading-snug textcolor5--text">
          Filter
        </font>
        <v-spacer></v-spacer>
        <v-btn
          class="btn btn-save rounded-xl mr-2"
          :disabled="!$auth.manage"
          v-if="!isHistory"
          @click="save"
          >{{ $t('btn.common.save') }}</v-btn
        >
        <v-btn
          class="btn btn-delete rounded-xl mr-2"
          :disabled="!$auth.manage || !formData.fltrId"
          v-if="!isHistory"
          @click="deleteFilter"
          >{{ $t('btn.common.delete') }}</v-btn
        >
        <v-btn class="btn btn-close rounded-xl" :disabled="!$auth.manage" @click="closeComDialog">{{
          $t('btn.common.close')
        }}</v-btn>
      </v-card-title>
    </template>
    <v-form ref="form" lazy-validation class="px-6 mt-5" style="height: 807px; overflow: auto">
      <v-row class="mt-0">
        <v-col cols="12" md="12" class="px-3 py-0">
          <div class="d-flex justify-space-between align-center">
            <v-label class="pt-2">{{ $t('lbl.filters.filterName') }}</v-label>
            <div class="right-text">
              <v-btn
                style="visibility: hidden;height:22px;"
                :disabled="isHistory"
                class="px-0"
                @click="copyData"
              >
                <icon-svg
                  style="visibility: visible;"
                  width="60"
                  height="22"
                  iconName="comp-copy"
                />
              </v-btn>
              <v-btn
                style="visibility: hidden;height:22px;"
                :disabled="isHistory"
                class="px-0"
                @click="clearData"
              >
                <icon-svg
                  style="visibility: visible;"
                  width="60"
                  height="22"
                  iconName="comp-clear"
                />
              </v-btn>
            </div>
          </div>
          <v-combobox
            v-model="comId"
            :items="filterList"
            :rules="[validationUtils.required]"
            :disabled="!$auth.manage"
            :readonly="isHistory"
            item-value="fltrId"
            item-text="fltrNm"
            autofocus
            solo
            @change="changeComponentData()"
          >
          </v-combobox>
        </v-col>
        <v-col cols="12" md="12" class="px-3 py-0">
          <v-label>
            <v-icon x-small class="mr-1">fa fa-asterisk</v-icon>
            {{ $t('lbl.filters.filterType') }}
          </v-label>
          <v-autocomplete
            v-model="formData.fltrTpCd"
            :rules="[validationUtils.required]"
            :items="fltrTpCdList"
            :disabled="!$auth.manage"
            :readonly="isHistory"
            solo
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" md="12" class="px-3 py-0">
          <v-label>
            <v-icon x-small class="mr-1">fa fa-asterisk</v-icon>
            {{ $t('lbl.filters.filterPattern') }}
          </v-label>
          <v-text-field
            v-if="formData.fltrTpCd != 'USERDATA'"
            v-model="formData.srcPttn"
            :rules="[validationUtils.required]"
            :disabled="!$auth.manage"
            :readonly="isHistory"
            solo
          ></v-text-field>
        </v-col>
        <v-col v-if="formData.fltrTpCd == 'USERDATA'" cols="12" md="6" class="px-3 pr-2 py-0">
          <v-text-field
            v-model="userData.key"
            :maxlength="50"
            solo
            placeholder="Key"
            :disabled="!$auth.manage"
            :readonly="isHistory"
            :rules="formData.fltrTpCd === 'USERDATA' ? [validationUtils.required] : []"
          ></v-text-field>
        </v-col>
        <v-col v-if="formData.fltrTpCd == 'USERDATA'" cols="12" md="6" class="pr-3 pl-2 py-0">
          <v-text-field
            v-model="userData.value"
            :maxlength="50"
            solo
            placeholder="Value"
            :disabled="!$auth.manage"
            :readonly="isHistory"
            :rules="formData.fltrTpCd === 'USERDATA' ? [validationUtils.required] : []"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-form>

    <discardChange
      ref="confirmDialog"
      detail="Discard Changes?"
      :showCancel="true"
      color="information"
      size="max"
      title="confirmDialog"
      @select-confirm="removeDialog()"
    ></discardChange>
    <dialogWindow
      ref="RegisteredSuccess"
      size="max"
      :detail="$t('msg.common.success.detail', ['Filter', 'created'])"
      color="success"
    ></dialogWindow>
    <dialogWindow
      ref="ModifiedSuccess"
      size="max"
      :detail="$t('msg.common.success.detail', ['Filter', 'modified'])"
      color="success"
    ></dialogWindow>
    <dialogWindow
      ref="deleteFltr"
      title="Delete Filter"
      size="max"
      :detail="$t('lbl.processSetup.delComponent', ['filter'])"
      color="confirmation"
      :showCancel="true"
      @select-ok="actionDel()"
    >
    </dialogWindow>
    <dialogWindow
      ref="AlertFilterSetup"
      size="max"
      :detail="checkDialogInfo"
      :color="checkDialogColor"
      @select-ok="$refs.AlertFilterSetup.dialog = false"
    >
    </dialogWindow>
  </dialog-drag>
</template>

<script>
import $ from 'jquery';
import EventBus from '@/vue-caas/views/process/component/event-bus.js';
import DialogDrag from '@/vue-dlb/components/vue-dialog-drag.vue';
import discardChange from '@/vue-dlb/components/DiscardChange.vue';
import IconSvg from '@/vue-caas/components/IconBase.vue';
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';
import cfg from '@/vue-caas/config/config.js';
import { getEditData } from '@/vue-caas/utils/process';
import { runSave } from '@/vue-caas/views/processnew/component/saveRunner.js';

export default {
  props: {
    id: String,
    options: Object,
    closeDialog: Function,
    dragStart: Function,
    dragEnd: Function,
    manage: {
      default: false,
    },
  },
  components: {
    dialogWindow,
    DialogDrag,
    discardChange,
    IconSvg,
  },
  data() {
    return {
      procIconSize: 16,
      isHistory: false,
      comId: '',
      nodeId: '',
      comTp: 'FLT',
      formData: {
        byProcSetup: true,
        fltrId: '',
        fltrNm: '',
        fltrTpCd: '',
        srcPttn: '',
      },
      loadFormData: {
        byProcSetup: true,
        fltrId: '',
        fltrNm: '',
        fltrTpCd: '',
        srcPttn: '',
      },
      userData: {
        key: '',
        value: '',
      },
      fltrTpCdList: [],
      checkDialogInfo: '',
      checkDialogColor: 'warning',
    };
  },
  created() {
    this.initialize();
    EventBus.$on('check-right-layer-change', this.closeComDialog);
  },
  methods: {
    copyData() {
      this.formData.fltrId = '';
      this.formData.fltrNm = '';
      this.comId = '';
      EventBus.$emit('change-component-data', '', this.nodeId);
    },
    clearData() {
      this.changeFilter('');
      this.comId = '';
    },
    changeComponentData() {
      if (this.comId && this.comId.value) {
        this.changeFilter(this.comId.value);
      } else {
        if (this.formData.fltrId) {
          this.changeFilter('');
        }
        this.formData.fltrNm = this.comId;
      }
      this.validateFilterName();
    },
    validateFilterName() {
      this.filterList.map((e) => {
        if (e.fltrNm === this.formData.fltrNm && e.fltrId !== this.formData.fltrId) {
          this.formData.fltrNm = '';
          this.comId = '';
          this.checkDialogInfo = `Filter name : ${e.text} have been created !`;
          this.checkDialogColor = 'warning';
          this.$refs.AlertFilterSetup.dialog = true;
          return;
        }
      });
    },
    initialize() {
      this.nodeId = this.options.item.data.nodeId;
      this.comTp = this.options.item.data.comTp;
      if (this.options.item.isHistory) this.isHistory = this.options.item.isHistory;
      this.fltrTpCdList = this.options.item.data.fltrTpCdList;
      this.changeFilter(this.options.item.data.comId);
    },
    changeFilter(id) {
      if (this.$refs.form) this.$refs.form.resetValidation();
      let index = this.filterList.findIndex((e) => e.fltrId == id);
      if (index > -1 && (this.manage || this.isHistory)) {
        this.formData = Object.assign({}, this.filterList[index]);
        this.loadFormData = Object.assign({}, this.filterList[index]);
        this.comId = Object.assign({}, this.filterList[index]);
        EventBus.$emit('change-component-data', id, this.nodeId);

        if (this.formData.fltrTpCd == 'USERDATA') {
          let data = this.formData.srcPttn.split('|');
          this.userData.key = data[0];
          this.userData.value = data[1];
        } else {
          this.userData.key = '';
          this.userData.value = '';
        }
      } else {
        this.formData = {
          byProcSetup: true,
          fltrId: '',
          fltrNm: '',
          fltrTpCd: '',
          srcPttn: '',
        };
        this.userData.key = '';
        this.userData.value = '';
        EventBus.$emit('change-component-data', '', this.nodeId);
      }
    },
    async save() {
      const result = await runSave(this, 'FLT', { mode: 'form', data: this.formData });
      if (!result.success) {
        console.log(result.message);
      }
    },
    deleteFilter() {
      if (cfg.isDlb) {
        this.$refs.deleteFltr.dialog = true;
      } else {
        this.$store
          .dispatch('getListUseInWorkflow', {
            type: 'COM',
            value: this.formData.fltrId,
          })
          .then((res) => {
            if (res.length > 0) {
              EventBus.$emit('openDelHistoryWorkflowDialog', res, this.formData, this.nodeId);
            } else {
              this.$refs.deleteFltr.dialog = true;
            }
          });
      }
    },
    actionDel() {
      let self = this;
      this.$store.dispatch('deleteFilter', { fltrId: this.formData.fltrId }).then(() => {
        console.log('--------- Delete Filter -----');
        this.$store.dispatch('getFilterSelectBoxList').then(() => {
          this.$refs.form.resetValidation();
          $('.proc-component.v-card.v-sheet').each(function() {
            let comp = $(this)[0].__vue__.$parent;
            if (comp.comTp == 'FLT') {
              if (comp.formData.fltrId === self.formData.fltrId) {
                comp.resetForm();
              }
            }
          });
          this.comId = '';
          this.changeFilter('');
        });
      });
    },
    closeComDialog() {
      this.checkDataChange();
    },

    checkDataChange() {
      if (this.formData.fltrTpCd == 'USERDATA') {
        this.formData.srcPttn = this.userData.key + '|' + this.userData.value;
      }
      this.formData.byProcSetup = true;
      let editedData = getEditData(this.formData, this.loadFormData);
      if (Object.keys(editedData).length !== 0) {
        this.$refs.confirmDialog.dialog = true;
      } else {
        this.removeDialog();
      }
    },
    removeDialog() {
      this.closeDialog(this.id);
    },
    selectDialog(obj) {
      this.dragStart(obj);
    },
    dialogDragEnd(obj) {
      this.dragEnd(obj);
    },
  },
  computed: {
    filterList() {
      return this.$store.getters.filterSelectBoxList;
    },
  },
};
</script>

<style></style>
